import { Injectable } from '@angular/core';
import { Case, CaseWrite } from 'src/app/shared/models/cases/case';

@Injectable({
  providedIn: 'root'
})
export class NewFileService {
  private _file: any;

  constructor() { }

  get file() {
    return this._file;
  }

  set file(c: any) {
    this._file = c;
  }

}
